import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { City } from '../model/city';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';

@Injectable({
    providedIn: 'root'
  })
  export class CityService{
  
    constructor(private _restClientService : RestClientService) { }


    getAllCities() {
        return this._restClientService.load<City[]>('city/get');
    }
      
    getCityById(cityId){
      return this._restClientService.load<City>('city/get/'+cityId);
    }
      
    putCity(city) {
      return  this._restClientService.put<City>(`city/update`, city);
    }
    
    postCity(city) {
      return  this._restClientService.save<City>('city/add', city);
    }
    
    


}      

    